module.exports = __webpack_public_path__ + "static/media/userLogged.4d2c3309.svg";